/**
 * 服務錯誤
 */
export const ServiceErrors = {
  /** 連接錯誤 */
  CONNECT_ERROR: 'CONNECT_ERROR',

  /** 連接超時 */
  CONNECT_TIMEOUT: 'CONNECT_TIMEOUT',

  // 会话已失效
  SESSION_INVALID: 'SESSION_INVALID',

  /** 未登錄 */
  LOGIN_REQUIRED: 'LOGIN_REQUIRED',

  // 登录态验证失败
  VERIFY_LOGIN_FAILED: 6,

  /** 未完善信息 */
  COMPLETE_ACCOUNT_INFO_REQUIRED: 'COMPLETE_ACCOUNT_INFO_REQUIRED',

  /** 未完善信息 */
  VERIFY_IDENTITY_REQUIRED: 'VERIFY_IDENTITY_REQUIRED',

  /** 需要开发商账号登录 */
  OWNER_REQUIRED: 'OWNER_REQUIRED',

  YEHE_ONLY: 'YEHE_ONLY',
};

/**
 * 针对告警进行分级，区分值班人关注点
 * @type {string}
 */
// front_crash：紧急 前端崩溃不可用
export const FRONT_CRASH = 'front_crash';

// front_warn：提醒 报错但基本可用
export const FRONT_WARN = 'front_warn';

// server_crash：紧急 Node异常不可用
export const SERVER_CRASH = 'server_crash';

// server_warn：提醒 报错但基本可用
export const SERVER_WARN = 'server_warn';
